export default "__VITE_ASSET__B2YtsLVd__"